// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"slide-handler_wrapper_x8Kv-","slot-wrapper":"slide-handler_slot-wrapper_AoGzr"};